import React, { useState, useRef } from "react";
import "./landingPageBanner.scss";
import PopupModal from "../../common/PopupModal";
import cignaLogoBlk from "../../assets/images/cigna-logo-blk.png";
import icMeet from "../../assets/images/ic-meet.png";
import reviewTheDentist from "../../assets/images/review-the-dentist.png";
import icLearn from "../../assets/images/ic-learn.png";
import seeEstimatedCosts from "../../assets/images/see-estimated-costs.png";
import profileBg from "../../assets/images/profile-bg.jpg";
import downArrowSmall from "../../assets/images/down-arrow-small.png";
import Header from "./Header";
import goliImg from "../../assets/images/goli-circle.png";
import thomasImg from "../../assets/images/thomas-circle.png";
import wongImg from "../../assets/images/wong-circle.png";

const LandingPageBanner = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const myDivRef = useRef(null);
  const myDivRef1 = useRef(null);

  const scrollToDiv = () => {
    myDivRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToDiv1 = () => {
    myDivRef1.current?.scrollIntoView({ behavior: "smooth" });
  };

  const RenderCenterPopupContent = () => {
    return <></>;
  };
  const RenderCenterPopupModal = () => {
    return (
      <PopupModal
        isOpen={openPopup}
        onClose={() => {
          setOpenPopup(!openPopup);
        }}
        popupHeading="How Brighter can help your practice grow"
        customRender={RenderCenterPopupContent}
        popupType="center"
        width="745px"
      />
    );
  };

  return (
    <>
      <Header />
      <div className="homeBannerWrapper">
        <div className="homepage-banner new-wrapper">
          <h1 className="bannerHeading">
            Connecting millions of patients
            <br />
            with top providers.
          </h1>
          <p>
            Access your free Brighter Profile to start growing your practice
            today.
          </p>
          <button
            className="LearnMoreBtn"
            onClick={() => {
              setOpenPopup(!openPopup);
            }}
          >
            {" "}
            Learn More
          </button>
        </div>
      </div>

      <div className="carriers-block new-wrapper">
        <div className="carrier-logo-block">
          <p>Brighter powers Cigna&apos;s online provider directories.</p>
          <img src={cignaLogoBlk} alt="Cigna-logo" />
        </div>
        <div className="stand-out">
          <h3>It all starts with your Brighter Profile.</h3>
          <h4>
            Bring your profile to life with photos, amenities, and verified
            patient reviews.
          </h4>
        </div>
        <div className="Profile-body">
          <div className="highlight-left">
            <div className="highlight-box">
              <h4>Using your Brighter profile members can:</h4>
              <ul className="list-inline">
                <li>
                  <img className="pull-left" src={icMeet} alt="" />
                  <h6 className="inline">Meet the dentist</h6>
                </li>
                <li>
                  <img className="pull-left" src={reviewTheDentist} alt="" />
                  <h6 className="inline">Review the dentist</h6>
                </li>
                <li>
                  <img className="pull-left lightbulb" src={icLearn} alt="" />
                  <h6 className="inline">Learn about the practice</h6>
                </li>
                <li>
                  <img className="pull-left" src={seeEstimatedCosts} alt="" />
                  <h6 className="inline">See estimated costs</h6>
                </li>
              </ul>
            </div>
          </div>
          <div className="highlight-right">
            <a
              className="video-overlay"
              onClick={() => {
                setOpenPopup(!openPopup);
              }}
            ></a>
            <img src={profileBg} alt="" />
          </div>
        </div>
      </div>
      <div className="learn-link">
        <a onClick={scrollToDiv}>
          Learn more <img alt="" src={downArrowSmall} />
        </a>
      </div>

      <div className="mid-banner" ref={myDivRef} id="mid-banner">
        <div className="container-fluid new-wrapper">
          <h1>Connect to patients, 24/7</h1>
          <p>
            Brighter makes it easy for loyal, well-informed <br /> patients to
            find your practice.
          </p>
        </div>
        <div className="learn-link">
          <a onClick={scrollToDiv1}>
            Learn more <img alt="" src={downArrowSmall} />
          </a>
        </div>
      </div>

      <div className="testimonials-block" ref={myDivRef1} id="testimonials">
        <h4>Here&apos;s what providers are saying about Brighter</h4>
        <ul className="testimonies">
          <li>
            <img src={goliImg} alt="" />
            <h4>Dr. Goli Javaher DDS</h4>
            <p>
              &quot;I can&apos;t say enough about Brighter.
              <br />
              Brighter understands what it takes to grow a<br />
              practice and sets me up for success.&quot;
            </p>
          </li>
          <li>
            <img src={wongImg} alt="" />
            <h4>Dr. Michael Wong DDS</h4>
            <p>
              &quot;Patients who use Brighter are knowledgeable
              <br />
              and very motivated to maintain good oral care.&quot;
            </p>
          </li>
          <li>
            <img src={thomasImg} alt="" />
            <h4>Dr. Thomas McCulloch DDS</h4>
            <p>
              &quot;It only took 5 minutes to get my profile set up.
              <br />
              It was quick and easy and the Brighter staff provided
              <br />
              me with excellent customer service.&quot;
            </p>
          </li>
        </ul>
        <p className="testimonials-p">
          Create your Brighter Profile today. Provider questions? 424-316-2534
        </p>
      </div>
      {openPopup && RenderCenterPopupModal()}
    </>
  );
};

export default LandingPageBanner;
